import React from "react";
import { RxCross2 } from "react-icons/rx";

const ModalHeader = ({ name, closeModal }) => {
  return (
    <div className="flex w-full items-center justify-between gap-4 px-5 py-4 sm:px-8 sm:py-5">
      <div className="min-w-0 text-gray-800 font-semibold text-sm sm:text-base line-clamp-2">
        {name}
      </div>
      <button
        type="button"
        aria-label="Close image preview"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-gray-700 transition hover:bg-black/5 hover:text-black"
        onClick={() => closeModal(false)}
      >
        <RxCross2
          size={24}
        />
      </button>
    </div>
  );
};

export default ModalHeader;
